import React, { useEffect, useState } from 'react';
import { getCourses } from '../../../services/courseService';
import CourseTable from './CourseTable';
import { Button, Divider, Form, Space, Typography } from 'antd';
import CourseAdd from '../CourseAdd';
import { getParams } from '../../../utilities/filterConstructor';
import CourseSearch from './CourseSearch';
import { useHistory } from 'react-router-dom';

import { getFeedbackTemplate } from '../../../services/feedbackTemplateService';

const { Title } = Typography;

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [visibleAddModal, setVisibleAddModel] = useState(false);
  const onClickModal = () => {
    setVisibleAddModel(true);
  };
  const history = useHistory();

  const onClickAddFreeworkshop = () => {
    history.push('/add-freeworkshop');
  };

  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [offset, setOffset] = useState((current - 1) * pageSize);

  const [totalCount, setTotalCount] = useState(0);
  const [currentParams, setCurrentParams] = useState({});
  const [fetching, setFetching] = useState(false);

  const [status, setStatus] = useState({
    type: 'LOADING',
    message: 'Loading data..'
  });

  const [feedbackTemplates, setFeedbackTemplates] = useState([]);

  const getData = async (
    newParams,
    limit = pageSize,
    currentPage = current
  ) => {
    const params = newParams ? newParams : currentParams;
    setFetching(true);
    await getCourses(currentPage, limit, params)
      .then((response) => {
        const courseList = response.data.paginatedList;
        setTotalCount(response.data.totalCount);
        setCourses(courseList);
        setFetching(false);
      })
      .catch((error) => {
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
        setFetching(false);
      });

    await getFeedbackTemplate()
      .then((response) => {
        setFeedbackTemplates(
          response?.data?.paginatedList.filter(
            (template) => !template.isArchived
          )
        );
      })
      .catch((err) => {
        console.log('Error api failed.', err.response);
        setStatus({
          type: 'ERROR',
          message: err?.response?.data?.message ?? 'Something went wrong!',
          status: err?.response?.status ?? 400
        });
      });
  };

  const onPaginationChange = (data) => {
    setCurrent(data.current);
    setPageSize(data.pageSize);
    setOffset((data.current - 1) * data.pageSize);
    getData(currentParams, data.pageSize, data.current);
  };

  useEffect(
    (e) => {
      getData();
    },
    [current, currentParams]
  );

  const [form] = Form.useForm();

  const onSearch = (data) => {
    const params = getParams(data);
    setCurrentParams(params);
    setCurrent(1);
  };

  const onReset = () => {
    form.resetFields();
    setOffset(0);
    setCurrent(1);
    getData({}, pageSize, 1);
  };

  return (
    <div>
      <div>
        <Space size="large">
          <Title level={3}>Courses</Title>
          <Button type="ghost" onClick={onClickModal}>
            Add
          </Button>

          <Button type="ghost" onClick={onClickAddFreeworkshop}>
            Add Free Workshop
          </Button>

          <CourseAdd
            isOpen={visibleAddModal}
            toggle={() => setVisibleAddModel(false)}
            feedbackTemplates={feedbackTemplates}
          />
        </Space>
        <section>
          <CourseSearch
            onReset={onReset}
            onSearch={onSearch}
            form={form}
            initialValues={{ param: 'courseCodeSearch' }}
          />
        </section>
        <section>
          <CourseTable
            data={courses}
            onPaginationChange={onPaginationChange}
            current={current}
            totalCount={totalCount}
            offset={offset}
            fetching={fetching}
          />
        </section>
      </div>
    </div>
  );
};

export default Courses;
